import { buildTimeslotTask } from '@griply/services';
import { Timeslot, TimeslotTaskLink, Timestamp } from '@griply/types';
import { useCreateTask } from 'features/tasks';
import { useCallback } from 'react';

// Shared by the calendar drag/drop paths and the slot context menu.
export const useCreateTimeslotTask = () => {
  const { submit: createTask } = useCreateTask();

  return useCallback(
    (
      link: TimeslotTaskLink,
      eventDate: Timestamp,
      timeslot: Timeslot | null,
    ) => {
      const { task, tags } = buildTimeslotTask(link, eventDate, timeslot);
      if (tags) {
        createTask(task, { tags });
        return;
      }
      createTask(task);
    },
    [createTask],
  );
};
